export default __webpack_public_path__ + "static/media/rafSlide2.c4a4568e.png";